<template>
    <transition name="fade">
        <div class="confirm-body">
            <!-- 全屏Loading -->
            <div class="fullscreen-loading" v-if="confirm_loading">
                <div class="loading-spinner">
                    <div class="spinner"></div>
                    <div class="loading-desc">处理中,请稍候...</div>
                </div>
            </div>
            <div class="confirm-modal" v-if="!is_reject">
                <Icon class="close-icon" type="md-close" size="18" @click="close" />
                <img src="@/assets/images/shop-manage/icon-shop-manage-recive.png" alt="" class="tips-icon">
                <div class="main-tips">请确认是否已收到货?</div>
                <div class="sub-tips" v-if="order.type == 1">确认收货后将自动进入换货发货流程</div>
                <div class="btn confirm" :class="{ loading: confirm_loading, disabled: confirm_loading }" @click="onConfirmRecive">
                    <span v-if="confirm_loading" class="loading-text">处理中...</span>
                    <span v-else>确认收货</span>
                </div>
                <div class="btn reject" :class="{ disabled: confirm_loading }" @click="!confirm_loading && (is_reject=true)">拒绝收货<span>(需填写原因)</span></div>
            </div>
            <div class="reject-modal" v-else>
                <Icon class="reject-close" type="md-close" size="18" @click="close" />
                <div class="reject-title">
                    <img src="@/assets/images/shop-manage/icon-shop-manage-reject.png" alt="" class="reject-icon" />
                    <div class="title">拒绝收货原因填写</div>
                </div>
                <div class="reject-desc">请填写拒收的详细信息,提交后将由平台审核</div>
                <div class="reject-form">
                    <div class="reject-form-item">
                        <div class="reject-label required">拒收原因</div>
                        <Select placeholder="请选择拒收的核心原因" v-model="form.shop_reason">
                            <Option value="商品破损、污渍(影响二次销售)">商品破损、污渍(影响二次销售)</Option>
                            <Option value="商品款式/尺码/颜色与订单不符">商品款式/尺码/颜色与订单不符</Option>
                            <Option value="商品配件不全(吊牌、包装等缺失)">商品配件不全(吊牌、包装等缺失)</Option>
                            <Option value="疑似非本店售出商品">疑似非本店售出商品</Option>
                            <Option value="其它原因">其它原因</Option>
                        </Select>
                    </div>
                    <div class="reject-form-item">
                        <div class="reject-label required">上传凭证<span>(破损照片、对比图等)</span></div>
                        <div class="reject-value upload-value">
                            <div class="upload-item" v-for="(item,index) in form.shop_proof" :key="index">
                                <img v-viewer :src="item" alt="" class="upload-img" />
                                <img @click.stop="onImgDelete(index)" src="@/assets/images/icon-close-circle.png" alt="" class="delete-icon" />
                            </div>
                            <Upload v-if="form.shop_proof.length < 3" action="/" multiple :data="{ dir: 'template' }" :before-upload="(file)=>onBeforeUpload(file)">
                                <div class="upload-btn">
                                    <Icon type="md-add" size="32" color="#999999" />
                                    <div class="btn-text">上传图片</div>
                                </div>
                            </Upload>
                        </div>
                        <div class="tips">支持JPG/PNG格式,单张不超过3M,最多上传3张</div>
                    </div>
                    <div class="reject-form-item">
                        <div class="reject-label">补充说明(选填)</div>
                        <div class="reject-value">
                            <Input type="textarea" v-model="form.shop_memo" :rows="4" placeholder="请输入补充说明" />
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <div class="btn cancel" :class="{ disabled: confirm_loading }" @click="!confirm_loading && close()">取消</div>
                    <div class="btn confirm" :class="{ loading: confirm_loading, disabled: confirm_loading }" @click="onRejectConfirm">
                        <span v-if="confirm_loading" class="loading-text">处理中...</span>
                        <span v-else>提交审核</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { receiveExchangeGoods, rejectExchangeGoods } from '@/api/index';
import { uploadFileToOSS } from "@/utils/oss";
export default{
    name:"OrderExchangeRecive",
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
            is_reject:false,
            form:{
                uuid:'',
                shop_reason:'',
                shop_proof:[],
                shop_memo:''
            },
            confirm_loading:false
        }
    },
    mounted(){
        console.log('this.order',this.order);
        this.form.uuid = this.order.uuid;
    },
    methods:{
        async onConfirmRecive(){
            if(this.confirm_loading) return;
            this.confirm_loading = true;
            try{
                const {code,msg} = await receiveExchangeGoods({uuid:this.form.uuid});
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$bus.$emit('list-refresh');
                this.close();
            }catch(e){
                console.log('err-confirm',e);
                this.$layer.msg('操作失败,请重试');
            }finally{
                this.confirm_loading = false;
            }
        },
        async onRejectConfirm(){
            if(this.confirm_loading) return;
            if(!this.form.shop_reason){
                this.$layer.msg('请选择拒收的核心原因');
                return;
            }
            if(!this.form.shop_proof.length){
                this.$layer.msg('请上传拒收的凭证');
                return;
            }
            this.confirm_loading = true;
            try{
                const {code,msg} = await rejectExchangeGoods(this.form);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('提交成功,请耐心等待平台审核');
                this.$bus.$emit('list-refresh');
                this.close();
            }catch(e){
                console.log('err->reject-confirm',e);
                this.$layer.msg('操作失败,请重试');
            }finally{
                this.confirm_loading = false;
            }
        },
        onImgDelete(index){ 
            this.form.shop_proof.splice(index,1);
        },
        onBeforeUpload(file){
            uploadFileToOSS(file, "template").then(url=>{
                if(this.form.shop_proof.length >= 3){
                    this.$layer.msg('图片数量不能超过3张');
                    return;
                }
                this.form.shop_proof.push(url);
                // console.log(this.form.shop_proof,'shop-proof');
            }).catch(e=>{
                console.log('err-upload',e);
            })
            return false;
        },
        close(){
            this.$emit('close');
        }
    }
}
</script>
<style lang="scss" scoped>
    .confirm-body{
        width:100%;
        height:100%;
        position:fixed;
        top:0;
        left:0;
        z-index:110;
        background:rgba(0,0,0,0.5);
        display:flex;
        align-items:center;
        justify-content:center;
        .fullscreen-loading{
            position:fixed;
            top:0;
            left:0;
            width:100%;
            height:100%;
            z-index:200;
            background:rgba(0,0,0,0.6);
            display:flex;
            align-items:center;
            justify-content:center;
            .loading-spinner{
                display:flex;
                flex-direction:column;
                align-items:center;
                row-gap:16px;
                .spinner{
                    width:40px;
                    height:40px;
                    border:3px solid rgba(255,255,255,0.3);
                    border-top-color:#fff;
                    border-radius:50%;
                    animation:spin 0.8s linear infinite;
                }
                .loading-desc{
                    color:#fff;
                    font-size:14px;
                }
            }
        }
        @keyframes spin{
            to{transform:rotate(360deg);}
        }
        .confirm-modal{
            width:500px;
            background:#fff;
            border-radius:10px;
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            padding:0 40px;
            position:relative;
            .close-icon{
                position:absolute;
                top:16px;
                right:16px;
                cursor:pointer;
            }
            .tips-icon{
                width:127px;
                height:121px;
            }
            .main-tips{
                color:#0f1115;
                font-weight:bold;
                font-size:24px;
                margin-top:8px;
            }
            .sub-tips{
                margin-top:11px;
                color:#666;
                font-size:14px;
            }
            .btn{
                width:100%;
                height:48px;
                line-height:48px;
                font-size:16px;
                font-weight:bold;
                border-radius:4px;
                text-align:center;
                cursor:pointer;
                &:last-child{
                    margin-bottom:38px;
                }
                span{
                    font-size:16px;
                    font-weight:400;
                }
                &.confirm{
                    margin-top:37px;
                    margin-bottom: 20px;
                    color:#fff;
                    background:#ff5967;
                    &.loading{
                        opacity:0.7;
                        pointer-events:none;
                    }
                    &.disabled{
                        pointer-events:none;
                    }
                }
                &.reject{
                    color:#666;
                    border:1px solid #e3e3e3;
                }
                &.disabled{
                    opacity:0.5;
                    pointer-events:none;
                }
            }
        }
        .reject-modal{
            width:508px;
            background:#fff;
            border-radius:10px;
            position:relative;
            padding:0 24px;
            display:flex;
            flex-direction: column;
            .reject-close{
                position:absolute;
                top:16px;
                right:16px;
                cursor:pointer;
            }
            .reject-title{
                display:flex;
                align-items:center;
                column-gap:11px;
                margin-top:8px;
                .reject-icon{
                    width:60px;
                    height:60px;
                }
                .title{
                    color:#0f1115;
                    font-size:18px;
                    font-weight:bold;
                }
            }
            .reject-desc{
                color:#666;
                font-size:14px;
            }
            .reject-form{
                margin-top:27px;
                display:flex;
                flex-direction: column;
                row-gap:24px;
                .reject-form-item{
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    .reject-label{
                        color:#333;
                        font-size:14px;
                        span{
                            color:#999;
                        }
                        &.required::after{
                            content:'*';
                            color:red;
                        }
                    }
                    .reject-value{
                        width:100%;
                        &.upload-value{
                            display:flex;
                            column-gap:10px;
                            .upload-item,.upload-btn{
                                width:80px;
                                height:80px;
                                border:1px solid #e3e3e3;
                                border-radius:4px;
                            }
                            .upload-btn{
                                display:flex;
                                flex-direction:column;
                                align-items:center;
                                justify-content: center;
                                row-gap:3px;
                                cursor:pointer;
                                .btn-text{
                                    color:#999;
                                    font-size:12px;
                                }
                            }
                            .upload-item{
                                position:relative;
                                .upload-img{
                                    width:100%;
                                    height:100%;
                                    border-radius:4px;
                                }
                                .delete-icon{
                                    position:absolute;
                                    top:0;
                                    right:0;
                                    cursor:pointer;
                                    width:16px;
                                    height:16px;
                                }
                            }
                        }
                    }
                    .tips{
                        color:#999999;
                        font-size:12px;
                    }
                }

            }
            .btn-box{
                width:100%;
                display:flex;
                justify-content:center;
                align-items:center;
                column-gap:10px;
                padding-top:14px;
                margin-bottom:27px;
                border-top:1px solid #e3e3e3;
                .btn{
                    font-size:14px;
                    cursor:pointer;
                    font-weight:bold;
                    height:40px;
                    line-height:40px;
                    border-radius:4px;
                    &.cancel{
                        color:#666;
                        border:1px solid #e3e3e3;
                        padding:0 36px;
                    }
                    &.confirm{
                        color:#fff;
                        background:#ff5967;
                        padding:0 34px;
                        &.loading{
                            opacity:0.7;
                            pointer-events:none;
                        }
                        &.disabled{
                            pointer-events:none;
                        }
                    }
                    &.disabled{
                        opacity:0.5;
                        pointer-events:none;
                    }
                }
            }
        }
    }
</style>